// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* src/pages/cpaCareerQuiz/styles/quiz.scss */
.quiz-page .quiz-progress {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}
.quiz-page .quiz-progress__meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.quiz-page .quiz-progress__bar {
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.quiz-page .quiz-progress__fill {
  height: 100%;
  background: #224040;
  border-radius: 999px;
  transition: width 0.25s ease;
}
.quiz-page .quiz-option {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  margin-bottom: 12px;
  cursor: pointer;
}
.quiz-page .quiz-option input {
  margin-top: 3px;
}
.quiz-page .quiz-option__text {
  line-height: 1.6;
}
.quiz-page .result-card {
  max-width: 900px;
  margin: 0 auto;
  padding: 18px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  background: #fff;
}
.quiz-page .result-badge {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(34, 64, 64, 0.12);
  color: #224040;
  font-weight: 600;
}
.quiz-page .leadgen {
  max-width: 900px;
  margin: 30px auto 0;
  padding: 18px;
  border-radius: 14px;
  background: rgba(34, 64, 64, 0.06);
}

.quiz-page .result-image-wrap {
  width: 100%;
  margin: 0 auto 14px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.quiz-page .result-image {
  width: 100%;
  height: auto;
  display: block;
}

/* =========================
   Start Page 橘色背景
========================= */
.start-hero {
  position: relative;
  background: linear-gradient(135deg, #f5c644, #ffc23d);
  color: white;
  overflow: hidden;
  /* 讓文字在人物圖之上 */
}
.start-hero > * {
  position: relative;
  z-index: 2;
}
.start-hero .action-button {
  background: white;
  color: #ff7a18;
  border-color: white;
}

.testsubtext {
  text-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
}

/* =========================
   四角人物圖
========================= */
.hero-person {
  position: absolute;
  animation: float 6s ease-in-out infinite;
  width: 200px;
  pointer-events: none;
  z-index: 1;
}

@keyframes float {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
  100% {
    transform: translateY(0);
  }
}
/* 左上 */
.p1 {
  top: 20%;
  left: 20px;
}

/* 右上 */
.p2 {
  top: 20%;
  right: 20px;
}

/* 左下 */
.p3 {
  bottom: 10px;
  left: 20px;
}

/* 右下 */
.p4 {
  bottom: 20px;
  right: 20px;
}

/* =========================
   手機版調整
========================= */
@media (max-width: 768px) {
  .start-hero .hero-person {
    display: none !important;
  }
  .start-hero {
    padding-bottom: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/cpaquiz/styles/psytest.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,6CAAA;AAEE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AACN;AACI;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,+BAAA;EACA,gBAAA;AACN;AACI;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,4BAAA;AACN;AAGE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAGI;EAAQ,eAAA;AAAZ;AACI;EAAU,gBAAA;AAEd;AACE;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAEE;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;AADJ;;AAKE;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;AAFJ;AAKE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAHJ;;AAOA;;2BAAA;AAGA;EACE,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,gBAAA;EAEA,cAAA;AALF;AAME;EACE,kBAAA;EACA,UAAA;AAJJ;AASE;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;AAPJ;;AAUA;EACE,yCACM;AARR;;AAUA;;2BAAA;AAGA;EACE,kBAAA;EACA,wCAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;AAPF;;AASA;EACE;IAAK,wBAAA;EALL;EAMA;IAAM,2BAAA;EAHN;EAIA;IAAO,wBAAA;EADP;AACF;AAGA,OAAA;AACA;EACE,QAAA;EACA,UAAA;AADF;;AAIA,OAAA;AACA;EACE,QAAA;EACA,WAAA;AADF;;AAIA,OAAA;AACA;EACE,YAAA;EACA,UAAA;AADF;;AAIA,OAAA;AACA;EACE,YAAA;EACA,WAAA;AADF;;AAIA;;2BAAA;AAGA;EACE;IACE,wBAAA;EADF;EAIA;IACE,oBAAA;EAFF;AACF","sourcesContent":["/* src/pages/cpaCareerQuiz/styles/quiz.scss */\r\n.quiz-page {\r\n  .quiz-progress {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    padding: 0 15px;\r\n\r\n    &__meta {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      margin-bottom: 8px;\r\n    }\r\n    &__bar {\r\n      width: 100%;\r\n      height: 8px;\r\n      border-radius: 999px;\r\n      background: rgba(0,0,0,0.08);\r\n      overflow: hidden;\r\n    }\r\n    &__fill {\r\n      height: 100%;\r\n      background: #224040;\r\n      border-radius: 999px;\r\n      transition: width .25s ease;\r\n    }\r\n  }\r\n\r\n  .quiz-option {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: flex-start;\r\n    padding: 12px 10px;\r\n    border: 1px solid rgba(0,0,0,0.08);\r\n    border-radius: 10px;\r\n    margin-bottom: 12px;\r\n    cursor: pointer;\r\n\r\n    input { margin-top: 3px; }\r\n    &__text { line-height: 1.6; }\r\n  }\r\n\r\n  .result-card {\r\n    max-width: 900px;\r\n    margin: 0 auto;\r\n    padding: 18px;\r\n    border: 1px solid rgba(0,0,0,0.08);\r\n    border-radius: 14px;\r\n    background: #fff;\r\n  }\r\n\r\n  .result-badge {\r\n    display: inline-block;\r\n    padding: 6px 10px;\r\n    border-radius: 999px;\r\n    background: rgba(34,64,64,0.12);\r\n    color: #224040;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .leadgen {\r\n    max-width: 900px;\r\n    margin: 30px auto 0;\r\n    padding: 18px;\r\n    border-radius: 14px;\r\n    background: rgba(34,64,64,0.06);\r\n  }\r\n}\r\n.quiz-page {\r\n  .result-image-wrap {\r\n    width: 100%;\r\n    margin: 0 auto 14px;\r\n    border-radius: 14px;\r\n    overflow: hidden;\r\n    border: 1px solid rgba(0,0,0,0.08);\r\n  }\r\n\r\n  .result-image {\r\n    width: 100%;\r\n    height: auto;\r\n    display: block;\r\n  }\r\n}\r\n\r\n/* =========================\r\n   Start Page 橘色背景\r\n========================= */\r\n.start-hero {\r\n  position: relative;\r\n  background: linear-gradient(135deg, #f5c644, #ffc23d);\r\n  color: white;\r\n  overflow: hidden;\r\n\r\n  /* 讓文字在人物圖之上 */\r\n  > * {\r\n    position: relative;\r\n    z-index: 2;\r\n  }\r\n\r\n\r\n\r\n  .action-button {\r\n    background: white;\r\n    color: #ff7a18;\r\n    border-color: white;\r\n  }\r\n}\r\n.testsubtext {\r\n  text-shadow: \r\n        0 2px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n/* =========================\r\n   四角人物圖\r\n========================= */\r\n.hero-person {\r\n  position: absolute;\r\n  animation: float 6s ease-in-out infinite;\r\n  width: 200px;\r\n  pointer-events: none;\r\n  z-index: 1;\r\n}\r\n@keyframes float {\r\n  0% { transform: translateY(0); }\r\n  50% { transform: translateY(-8px); }\r\n  100% { transform: translateY(0); }\r\n}\r\n\r\n/* 左上 */\r\n.p1 {\r\n  top: 20%;\r\n  left: 20px;\r\n}\r\n\r\n/* 右上 */\r\n.p2 {\r\n  top: 20%;\r\n  right: 20px;\r\n}\r\n\r\n/* 左下 */\r\n.p3 {\r\n  bottom: 10px;\r\n  left: 20px;\r\n}\r\n\r\n/* 右下 */\r\n.p4 {\r\n  bottom: 20px;\r\n  right: 20px;\r\n}\r\n\r\n/* =========================\r\n   手機版調整\r\n========================= */\r\n@media (max-width: 768px) {\r\n  .start-hero .hero-person {\r\n    display: none !important;\r\n  }\r\n\r\n  .start-hero {\r\n    padding-bottom: 40px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
